import { render, staticRenderFns } from "./ControlDetail.vue?vue&type=template&id=6cd31144&scoped=true"
import script from "./ControlDetail.vue?vue&type=script&lang=ts"
export * from "./ControlDetail.vue?vue&type=script&lang=ts"
import style0 from "./ControlDetail.vue?vue&type=style&index=0&id=6cd31144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd31144",
  null
  
)

export default component.exports